export default __webpack_public_path__ + "static/media/A_lopetus8.fa942707.mp3";